import React from 'react';
import { Box } from '@mui/material';

const GLOBAL_NAV_PLACEHOLDER = { height: '64px', background: 'grey' };

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'hb-global-navigator': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export default function GlobalNavigator(): JSX.Element {
  const isLocal = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
  const globalNavStyle = isLocal ? GLOBAL_NAV_PLACEHOLDER : undefined;

  return (
    <Box className="global-nav-wrapper" style={globalNavStyle}>
      <hb-global-navigator app-origin={window.location.origin} display-mode="panel" />
    </Box>
  );
}
